export type SegmentImportError = {
  activity_title: string;
  segment_title: string;
  message: string;
};

export type ForumClassicTimelineImportResult = {
  topic_id: string;
  activity_count: number;
  page_count: number;
  import_status: "complete" | "partial";
  segment_errors: SegmentImportError[];
};

export function parseForumClassicSegmentErrors(data: unknown): SegmentImportError[] {
  if (!data || typeof data !== "object" || !("segment_errors" in data)) {
    return [];
  }
  const segmentErrors = (data as { segment_errors?: unknown }).segment_errors;
  if (!Array.isArray(segmentErrors)) {
    return [];
  }
  return segmentErrors.filter(
    (error): error is SegmentImportError =>
      !!error &&
      typeof error === "object" &&
      typeof (error as SegmentImportError).activity_title === "string" &&
      typeof (error as SegmentImportError).segment_title === "string" &&
      typeof (error as SegmentImportError).message === "string",
  );
}
